import {View} from './view';

export class DynamicSubscriptionView extends View {
    dynamicSubscriptionRender(currencySign: any, amount: any) {
        const form: HTMLElement = document.createElement('form');
        form.classList.add('hs-form', 'stacked', 'df-f', 'df-f-dynamic-sub');

        form.innerHTML = `<fieldset class='form-columns-2 df-payment-field df-fieldset'>
             <div class='field hs-form-field df-field'>
               <label>
                 <span class='df-f-label'>Amount, ${currencySign}</span>
                 <span class='hs-form-required'>*</span>
               </label>
               <div class='input'>
                 <input id='amount' name='amount' class='hs-input amount dpi-amount df-input' type='text' size='4' autocomplete='off' required value='${amount}'/>
                   </div>
               </div>
             <div class='field hs-form-field df-field'>
               <label>
                 <span class='df-f-label'>Every</span>
               </label>
                       <select id='dynamic-plan-interval' class='hs-input dynamic-plan-interval df-select' >
                           <option value='day'>Day</option>
                           <option value='week'>Week</option>
                           <option value='month' selected='selected'>Month</option>
                           <option value='year'>Year</option>
                       </select>
                   </div>
               </fieldset>`;
        const container = this.getDFContainer();
        container.appendChild(form);
    }
    getSubscriptionPlan(): string | null {
        const selectElement = document.querySelector('#dynamic-plan-interval') as HTMLSelectElement;

        if (selectElement) {
            // Get the first selected option
            const option = selectElement.selectedOptions.item(0);

            return option ? option.value : null;
        }

        return null;
    }
}
